import { formatNumberLocale } from '../../../_utils'
import * as DateFns from 'date-fns'

export function getColumns(isPublisher:boolean) {
  const columns = [
      ...(isPublisher ? [] : [{
      name: 'Order ref',
      key: 'orderRef',
      selector: (row:any) => row.orderRef,
      sortable: true,wrap: true,
      searchable: true,
      }]),
      {
          name: 'Network',
          key:'network',
          selector: (row:any) => row.network,
          sortable: true,
          wrap: true,
          searchable:true
        },
        {
          name: 'Country',
          key:'country',
          selector: (row:any) => row.country,
          sortable: true,
          wrap: true,
          searchable: true
        },
        {
          name: 'Campaign',
          key: 'campaignName',
          selector: (row:any) => row.campaignName,
          sortable: true,
          wrap: true,
          searchable:true
        },
        ...(isPublisher ? [] : [{
          name: 'Publisher',
          key: 'affiliateName',
          selector: (row:any) => row.affiliateName,
          sortable: true,
          wrap: true,
          searchable:true
        }]),
    {
      name: 'Status',
      key: 'status',
      selector: (row:any) => row.status,
      format: (row:any) => String(row.status || 'Unknown')
        .replace(/[_-]+/g, ' ')
        .replace(/\b\w/g, character => character.toUpperCase()),
      sortable: true,
      wrap: true, 
      searchable:true,
    },
    ...(isPublisher ? [] : [{
      name: 'Amount',
      key: 'orderAmount',
      selector: (row:any) => row.orderAmount,
      format: (row:any) => formatNumberLocale(Number(row.orderAmount), 2),
      sortable: true,wrap: true,
    }]),
    {
      name: isPublisher ? 'Commission' : 'Cost',
      key: 'commission',
      selector: (row:any) => row.commission,
      format: (row:any) => formatNumberLocale(Number(row.commission), 2),
      sortable: true,wrap: true,
    },
    {
      name: 'Reference',
      key: 'ref',
      selector: (row:any) => row.ref,
      sortable: true,
      wrap: true,
      searchable:true
    },
    {
      name: 'Date',
      key: 'date',
      selector: (row:any) => row.date,
      format: (row:any) => {
        const date = new Date(row.date)
        return DateFns.isValid(date)
          ? DateFns.format(date, 'yyyy-MM-dd HH:mm:ss')
          : row.date
      },
      sortable: true,
      wrap: true,
      id:'date',
      searchable:true
    },
  ]
  return columns
}
